export const HeaderChip = ({
    puntaje,
    claseMonitoreo
}) => {
    return (
        <div className='header-chip-container'>
            <div className='header-chip'>
                <strong>Puntos: {puntaje} </strong>
                <span>   |   </span>
                <strong> {claseMonitoreo}</strong>
            </div>
        </div>
    )
}